import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../App/redux/store';
import LeftBand from '../features/auth/components/login/leftBand/LeftBand';

import { useEffect } from 'react';
import { getAuthState } from '../features/auth/authSlice';
import './styles/MaintenancePage.scss';

const MaintenancePage = () => {
  const { maintenancePageOnly, isLogged } = useAppSelector(getAuthState);
  const navigate = useNavigate();

  useEffect(() => {
    //access only if maintenance value is on
    if (!maintenancePageOnly) {
      navigate(isLogged ? '/dashboard' : '/connexion', { replace: true });
    }
  }, [maintenancePageOnly]);

  return (
    <div className="App">
      <div className="maintenance">
        <LeftBand />
        <main className="maintenance-content">
          <div className="maintenance-content-title">
            <h1>Maintenance en cours ...</h1>
            <p>
              Chers utilisateurs, <br />
              comme annoncé Prospec-Immo est aujourd’hui en maintenance
              <br /> pour vous garantir une qualité de service optimale.
            </p>
            <p>
              Début de la maintenance : <span>29/04/25 à 8h00</span>
            </p>
            <p>
              Fin de la maintenance : <span>29/04/25 à 18h00</span>
            </p>
            <p>Merci de votre compréhension.</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MaintenancePage;
